module.exports = __webpack_public_path__ + "dash_20_app_assets/img/facebookhow.3476d7d6.png";